import { __assign, __extends } from "tslib";
import { SQSServiceException as __BaseException } from "./SQSServiceException";
export var AddPermissionRequest;
(function (AddPermissionRequest) {
    AddPermissionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(AddPermissionRequest || (AddPermissionRequest = {}));
var OverLimit = (function (_super) {
    __extends(OverLimit, _super);
    function OverLimit(opts) {
        var _this = _super.call(this, __assign({ name: "OverLimit", $fault: "client" }, opts)) || this;
        _this.name = "OverLimit";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, OverLimit.prototype);
        return _this;
    }
    return OverLimit;
}(__BaseException));
export { OverLimit };
export var ChangeMessageVisibilityRequest;
(function (ChangeMessageVisibilityRequest) {
    ChangeMessageVisibilityRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ChangeMessageVisibilityRequest || (ChangeMessageVisibilityRequest = {}));
var MessageNotInflight = (function (_super) {
    __extends(MessageNotInflight, _super);
    function MessageNotInflight(opts) {
        var _this = _super.call(this, __assign({ name: "MessageNotInflight", $fault: "client" }, opts)) || this;
        _this.name = "MessageNotInflight";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, MessageNotInflight.prototype);
        return _this;
    }
    return MessageNotInflight;
}(__BaseException));
export { MessageNotInflight };
var ReceiptHandleIsInvalid = (function (_super) {
    __extends(ReceiptHandleIsInvalid, _super);
    function ReceiptHandleIsInvalid(opts) {
        var _this = _super.call(this, __assign({ name: "ReceiptHandleIsInvalid", $fault: "client" }, opts)) || this;
        _this.name = "ReceiptHandleIsInvalid";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ReceiptHandleIsInvalid.prototype);
        return _this;
    }
    return ReceiptHandleIsInvalid;
}(__BaseException));
export { ReceiptHandleIsInvalid };
var BatchEntryIdsNotDistinct = (function (_super) {
    __extends(BatchEntryIdsNotDistinct, _super);
    function BatchEntryIdsNotDistinct(opts) {
        var _this = _super.call(this, __assign({ name: "BatchEntryIdsNotDistinct", $fault: "client" }, opts)) || this;
        _this.name = "BatchEntryIdsNotDistinct";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, BatchEntryIdsNotDistinct.prototype);
        return _this;
    }
    return BatchEntryIdsNotDistinct;
}(__BaseException));
export { BatchEntryIdsNotDistinct };
export var ChangeMessageVisibilityBatchRequestEntry;
(function (ChangeMessageVisibilityBatchRequestEntry) {
    ChangeMessageVisibilityBatchRequestEntry.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ChangeMessageVisibilityBatchRequestEntry || (ChangeMessageVisibilityBatchRequestEntry = {}));
export var ChangeMessageVisibilityBatchRequest;
(function (ChangeMessageVisibilityBatchRequest) {
    ChangeMessageVisibilityBatchRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ChangeMessageVisibilityBatchRequest || (ChangeMessageVisibilityBatchRequest = {}));
export var BatchResultErrorEntry;
(function (BatchResultErrorEntry) {
    BatchResultErrorEntry.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(BatchResultErrorEntry || (BatchResultErrorEntry = {}));
export var ChangeMessageVisibilityBatchResultEntry;
(function (ChangeMessageVisibilityBatchResultEntry) {
    ChangeMessageVisibilityBatchResultEntry.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ChangeMessageVisibilityBatchResultEntry || (ChangeMessageVisibilityBatchResultEntry = {}));
export var ChangeMessageVisibilityBatchResult;
(function (ChangeMessageVisibilityBatchResult) {
    ChangeMessageVisibilityBatchResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ChangeMessageVisibilityBatchResult || (ChangeMessageVisibilityBatchResult = {}));
var EmptyBatchRequest = (function (_super) {
    __extends(EmptyBatchRequest, _super);
    function EmptyBatchRequest(opts) {
        var _this = _super.call(this, __assign({ name: "EmptyBatchRequest", $fault: "client" }, opts)) || this;
        _this.name = "EmptyBatchRequest";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, EmptyBatchRequest.prototype);
        return _this;
    }
    return EmptyBatchRequest;
}(__BaseException));
export { EmptyBatchRequest };
var InvalidBatchEntryId = (function (_super) {
    __extends(InvalidBatchEntryId, _super);
    function InvalidBatchEntryId(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidBatchEntryId", $fault: "client" }, opts)) || this;
        _this.name = "InvalidBatchEntryId";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidBatchEntryId.prototype);
        return _this;
    }
    return InvalidBatchEntryId;
}(__BaseException));
export { InvalidBatchEntryId };
var TooManyEntriesInBatchRequest = (function (_super) {
    __extends(TooManyEntriesInBatchRequest, _super);
    function TooManyEntriesInBatchRequest(opts) {
        var _this = _super.call(this, __assign({ name: "TooManyEntriesInBatchRequest", $fault: "client" }, opts)) || this;
        _this.name = "TooManyEntriesInBatchRequest";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, TooManyEntriesInBatchRequest.prototype);
        return _this;
    }
    return TooManyEntriesInBatchRequest;
}(__BaseException));
export { TooManyEntriesInBatchRequest };
export var CreateQueueRequest;
(function (CreateQueueRequest) {
    CreateQueueRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateQueueRequest || (CreateQueueRequest = {}));
export var CreateQueueResult;
(function (CreateQueueResult) {
    CreateQueueResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateQueueResult || (CreateQueueResult = {}));
var QueueDeletedRecently = (function (_super) {
    __extends(QueueDeletedRecently, _super);
    function QueueDeletedRecently(opts) {
        var _this = _super.call(this, __assign({ name: "QueueDeletedRecently", $fault: "client" }, opts)) || this;
        _this.name = "QueueDeletedRecently";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, QueueDeletedRecently.prototype);
        return _this;
    }
    return QueueDeletedRecently;
}(__BaseException));
export { QueueDeletedRecently };
var QueueNameExists = (function (_super) {
    __extends(QueueNameExists, _super);
    function QueueNameExists(opts) {
        var _this = _super.call(this, __assign({ name: "QueueNameExists", $fault: "client" }, opts)) || this;
        _this.name = "QueueNameExists";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, QueueNameExists.prototype);
        return _this;
    }
    return QueueNameExists;
}(__BaseException));
export { QueueNameExists };
export var DeleteMessageRequest;
(function (DeleteMessageRequest) {
    DeleteMessageRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteMessageRequest || (DeleteMessageRequest = {}));
var InvalidIdFormat = (function (_super) {
    __extends(InvalidIdFormat, _super);
    function InvalidIdFormat(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidIdFormat", $fault: "client" }, opts)) || this;
        _this.name = "InvalidIdFormat";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidIdFormat.prototype);
        return _this;
    }
    return InvalidIdFormat;
}(__BaseException));
export { InvalidIdFormat };
export var DeleteMessageBatchRequestEntry;
(function (DeleteMessageBatchRequestEntry) {
    DeleteMessageBatchRequestEntry.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteMessageBatchRequestEntry || (DeleteMessageBatchRequestEntry = {}));
export var DeleteMessageBatchRequest;
(function (DeleteMessageBatchRequest) {
    DeleteMessageBatchRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteMessageBatchRequest || (DeleteMessageBatchRequest = {}));
export var DeleteMessageBatchResultEntry;
(function (DeleteMessageBatchResultEntry) {
    DeleteMessageBatchResultEntry.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteMessageBatchResultEntry || (DeleteMessageBatchResultEntry = {}));
export var DeleteMessageBatchResult;
(function (DeleteMessageBatchResult) {
    DeleteMessageBatchResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteMessageBatchResult || (DeleteMessageBatchResult = {}));
export var DeleteQueueRequest;
(function (DeleteQueueRequest) {
    DeleteQueueRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteQueueRequest || (DeleteQueueRequest = {}));
export var GetQueueAttributesRequest;
(function (GetQueueAttributesRequest) {
    GetQueueAttributesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetQueueAttributesRequest || (GetQueueAttributesRequest = {}));
export var GetQueueAttributesResult;
(function (GetQueueAttributesResult) {
    GetQueueAttributesResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetQueueAttributesResult || (GetQueueAttributesResult = {}));
var InvalidAttributeName = (function (_super) {
    __extends(InvalidAttributeName, _super);
    function InvalidAttributeName(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidAttributeName", $fault: "client" }, opts)) || this;
        _this.name = "InvalidAttributeName";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidAttributeName.prototype);
        return _this;
    }
    return InvalidAttributeName;
}(__BaseException));
export { InvalidAttributeName };
export var GetQueueUrlRequest;
(function (GetQueueUrlRequest) {
    GetQueueUrlRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetQueueUrlRequest || (GetQueueUrlRequest = {}));
export var GetQueueUrlResult;
(function (GetQueueUrlResult) {
    GetQueueUrlResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetQueueUrlResult || (GetQueueUrlResult = {}));
var QueueDoesNotExist = (function (_super) {
    __extends(QueueDoesNotExist, _super);
    function QueueDoesNotExist(opts) {
        var _this = _super.call(this, __assign({ name: "QueueDoesNotExist", $fault: "client" }, opts)) || this;
        _this.name = "QueueDoesNotExist";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, QueueDoesNotExist.prototype);
        return _this;
    }
    return QueueDoesNotExist;
}(__BaseException));
export { QueueDoesNotExist };
export var ListDeadLetterSourceQueuesRequest;
(function (ListDeadLetterSourceQueuesRequest) {
    ListDeadLetterSourceQueuesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListDeadLetterSourceQueuesRequest || (ListDeadLetterSourceQueuesRequest = {}));
export var ListDeadLetterSourceQueuesResult;
(function (ListDeadLetterSourceQueuesResult) {
    ListDeadLetterSourceQueuesResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListDeadLetterSourceQueuesResult || (ListDeadLetterSourceQueuesResult = {}));
export var ListQueuesRequest;
(function (ListQueuesRequest) {
    ListQueuesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListQueuesRequest || (ListQueuesRequest = {}));
export var ListQueuesResult;
(function (ListQueuesResult) {
    ListQueuesResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListQueuesResult || (ListQueuesResult = {}));
export var ListQueueTagsRequest;
(function (ListQueueTagsRequest) {
    ListQueueTagsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListQueueTagsRequest || (ListQueueTagsRequest = {}));
export var ListQueueTagsResult;
(function (ListQueueTagsResult) {
    ListQueueTagsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListQueueTagsResult || (ListQueueTagsResult = {}));
var PurgeQueueInProgress = (function (_super) {
    __extends(PurgeQueueInProgress, _super);
    function PurgeQueueInProgress(opts) {
        var _this = _super.call(this, __assign({ name: "PurgeQueueInProgress", $fault: "client" }, opts)) || this;
        _this.name = "PurgeQueueInProgress";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, PurgeQueueInProgress.prototype);
        return _this;
    }
    return PurgeQueueInProgress;
}(__BaseException));
export { PurgeQueueInProgress };
export var PurgeQueueRequest;
(function (PurgeQueueRequest) {
    PurgeQueueRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PurgeQueueRequest || (PurgeQueueRequest = {}));
export var ReceiveMessageRequest;
(function (ReceiveMessageRequest) {
    ReceiveMessageRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ReceiveMessageRequest || (ReceiveMessageRequest = {}));
export var MessageAttributeValue;
(function (MessageAttributeValue) {
    MessageAttributeValue.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(MessageAttributeValue || (MessageAttributeValue = {}));
export var Message;
(function (Message) {
    Message.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Message || (Message = {}));
export var ReceiveMessageResult;
(function (ReceiveMessageResult) {
    ReceiveMessageResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ReceiveMessageResult || (ReceiveMessageResult = {}));
export var RemovePermissionRequest;
(function (RemovePermissionRequest) {
    RemovePermissionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(RemovePermissionRequest || (RemovePermissionRequest = {}));
var InvalidMessageContents = (function (_super) {
    __extends(InvalidMessageContents, _super);
    function InvalidMessageContents(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidMessageContents", $fault: "client" }, opts)) || this;
        _this.name = "InvalidMessageContents";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidMessageContents.prototype);
        return _this;
    }
    return InvalidMessageContents;
}(__BaseException));
export { InvalidMessageContents };
export var MessageSystemAttributeValue;
(function (MessageSystemAttributeValue) {
    MessageSystemAttributeValue.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(MessageSystemAttributeValue || (MessageSystemAttributeValue = {}));
export var SendMessageRequest;
(function (SendMessageRequest) {
    SendMessageRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SendMessageRequest || (SendMessageRequest = {}));
export var SendMessageResult;
(function (SendMessageResult) {
    SendMessageResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SendMessageResult || (SendMessageResult = {}));
var UnsupportedOperation = (function (_super) {
    __extends(UnsupportedOperation, _super);
    function UnsupportedOperation(opts) {
        var _this = _super.call(this, __assign({ name: "UnsupportedOperation", $fault: "client" }, opts)) || this;
        _this.name = "UnsupportedOperation";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, UnsupportedOperation.prototype);
        return _this;
    }
    return UnsupportedOperation;
}(__BaseException));
export { UnsupportedOperation };
var BatchRequestTooLong = (function (_super) {
    __extends(BatchRequestTooLong, _super);
    function BatchRequestTooLong(opts) {
        var _this = _super.call(this, __assign({ name: "BatchRequestTooLong", $fault: "client" }, opts)) || this;
        _this.name = "BatchRequestTooLong";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, BatchRequestTooLong.prototype);
        return _this;
    }
    return BatchRequestTooLong;
}(__BaseException));
export { BatchRequestTooLong };
export var SendMessageBatchRequestEntry;
(function (SendMessageBatchRequestEntry) {
    SendMessageBatchRequestEntry.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SendMessageBatchRequestEntry || (SendMessageBatchRequestEntry = {}));
export var SendMessageBatchRequest;
(function (SendMessageBatchRequest) {
    SendMessageBatchRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SendMessageBatchRequest || (SendMessageBatchRequest = {}));
export var SendMessageBatchResultEntry;
(function (SendMessageBatchResultEntry) {
    SendMessageBatchResultEntry.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SendMessageBatchResultEntry || (SendMessageBatchResultEntry = {}));
export var SendMessageBatchResult;
(function (SendMessageBatchResult) {
    SendMessageBatchResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SendMessageBatchResult || (SendMessageBatchResult = {}));
export var SetQueueAttributesRequest;
(function (SetQueueAttributesRequest) {
    SetQueueAttributesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SetQueueAttributesRequest || (SetQueueAttributesRequest = {}));
export var TagQueueRequest;
(function (TagQueueRequest) {
    TagQueueRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(TagQueueRequest || (TagQueueRequest = {}));
export var UntagQueueRequest;
(function (UntagQueueRequest) {
    UntagQueueRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UntagQueueRequest || (UntagQueueRequest = {}));
